import { parsePhoneNumber } from 'awesome-phonenumber';

export function isValidCountryPhone(value: string | null | undefined, regionIso: string): boolean {
  if (!value) return true;
  try {
    return parsePhoneNumber(value, { regionCode: regionIso }).valid;
  } catch {
    return false;
  }
}
